import React, { useState, useEffect } from 'react';
import { json, useNavigate } from 'react-router-dom';
import {
    Box, TextField, Button, Autocomplete, Grid, Typography, Paper,
    Accordion, AccordionSummary, AccordionDetails, FormControl,
    Select, MenuItem, IconButton, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Checkbox, ListItemText,
    FormHelperText, Divider, Alert, Modal, InputLabel
} from '@mui/material';
import CreatableSelect from 'react-select/creatable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import DeleteIcon from '@mui/icons-material/Delete';
import { CreditorService } from '../../services/creditorService';
import { CustomerService } from '../../services/customerService';
import { NumericFormat } from 'react-number-format';
import { PDFViewer } from '@react-pdf/renderer';
import AddIcon from '@mui/icons-material/Add';
import { SkipNext } from '@mui/icons-material';
//import PDF from '../components/pdf';
import PDF from '../document';
import Swal from 'sweetalert2';
import '../../components/swal.css'
import { Editor } from '@tinymce/tinymce-react';
import { formatToCLP } from '../../services/monedaService';

import { useSelector, useDispatch } from 'react-redux';
import { setContractFull, setTab, setPreAnexo } from '../../Redux/TabDucks';
import { getConsultantId } from '../../Redux/UsersDucks';
import { store } from '../../Redux/store';



// Función auxiliar para generar el número de contrato
const generateContractNumber = (sigla, date) => {
    const month = date.format('MM');
    const year = date.format('YYYY');
    const number = Math.floor(Math.random() * 99999) + 1; // Número aleatorio entre 1 y 99999
    return `${sigla}${month}${year}${number.toString().padStart(5, '0')}`;
};
const getFormattedDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const day = String(today.getDate()).padStart(2, '0'); // Asegura 2 dígitos para el día
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Mes comienza en 0
    return `${year}${month}${day}`;
};

const LineaNegocioForm = () => {
    const dispatch = useDispatch();
    const customer = useSelector((store) => store.tab.customerFormatted)
    const contractFull = useSelector((store) => store.tab.contractFull)
    const interview = useSelector((store) => store.tab.interview)
    const CttosOld = useSelector((store) => store.tab.CttosOld)
    const Sucursales = useSelector((store) => store.tab.Sucursales)
    const _TAB = useSelector((store) => store.tab)
    const preAnexo = useSelector((store) => store.tab.preAnexo)

    const [formData, setFormData] = useState({
        numContratos: '',
        rut: '',
        nombre: '',
        observaciones: '',
        fechaNegocio: dayjs(),
    });

    useEffect(() => console.log(preAnexo), [preAnexo])
    // Usar useEffect para inicializar los datos del cliente en formData
    useEffect(() => {
        if (customer) {
            setRutCod(`${processString(customer.rut)}${getFormattedDate()}`)
            setFormData(prevData => ({
                ...prevData,
                rut: customer.rut || '',  // Asignar el RUT del cliente
                nombre: `${customer.firstName} ${customer.lastName}`, // Asignar el nombre completo del cliente
            }));
        }
    }, [customer]);  // Ejecutar este efecto solo si customer cambia

    const [acreedoresList, setAcreedoresList] = useState([])
    const [negocioList, setNegocioList] = useState([])
    const [selectedNegocios, setSelectedNegocios] = useState([])
    const [serviciosByNegocio, setServiciosByNegocio] = useState({})
    const [selectedServicios, setSelectedServicios] = useState({})
    const [serviciosCost, setServiciosCost] = useState({})
    const [serviciosCausas, setServiciosCausas] = useState({})
    const [serviciosAcreedores, setServiciosAcreedores] = useState([])
    const [contractLayouts, setContractLayouts] = useState({})
    const [causasList, setCausasList] = useState([])

    const [selectedAcreedor, setSelectedAcreedor] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [montoDeuda, setMontoDeuda] = useState([])
    const [inputValue, setInputValue] = useState({}) // Para controlar el valor del input
    const [totalDeuda, setTotalDeuda] = useState('')
    const [allAcreedores, setAllAcreedores] = useState({ type: 'contract', list: [] })
    const [rutCod, setRutCod] = useState('')
    const navigate = useNavigate();

    const [content, setContent] = useState('')
    const [allowUpdate, setAllowUpdate] = useState(true);

    const [showAsignarCausas, setShowAsignarCausas] = useState(false);
    const [preFormattedData, setPreFormattedData] = useState(null);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const acreedores = await CreditorService.getAcreedores();
                const lineaNegocios = await CreditorService.getLineaNegocioByRut(customer.rut);
                //const lineaNegocios = await CreditorService.getLineaNegocio();
                const causas = await CreditorService.getCausasbyInterview(interview.id)
                setAcreedoresList(acreedores);
                setNegocioList(lineaNegocios);
                setCausasList(causas.causas);
            } catch (error) {
            }
        };

        fetchData();
    }, []);


    useEffect(() => {
        if (contractFull && contractFull.negocios && contractFull.negocios.length > 0) {
            var negocio = contractFull.negocios[0]
            if (negocio.urlFE) {
                setAllowUpdate(false)
            }
            else if (negocio.urlFEXL) {
                setAllowUpdate(false)
            } else {
                setAllowUpdate(true)
            }
        } else {
            setAllowUpdate(true)
        }

        if (contractFull?.numContratos) {

            handleNegocioChange(null, contractFull.negocios, contractFull.montoAnexo, contractFull.motivoContratoId).then((result) => {
                contractFull.negocios.forEach(negocio => {
                    const negocioId = negocio.lineId ? negocio.lineId : negocio.id
                    handleServicioChange(negocioId, negocio.servicios);
                    negocio.servicios.forEach(servicio => {
                        handleServicioCostChange(negocioId, servicio.id, servicio.costo)
                    });
                });
            });

            if (contractFull?.negocios) {
                contractFull.negocios?.map((negocio, index) => {
                    const negocioId = negocio.lineId ? negocio.lineId : negocio.id
                    negocio.servicios?.map((servicio) => {
                        servicio.acreedores?.map((acreedor) => {
                            setServiciosAcreedores((prev) => ({
                                ...prev,
                                [negocioId]: {
                                    ...prev[negocioId],
                                    [servicio.id]: [
                                        ...(prev[negocioId]?.[servicio.id] || []),
                                        { nombre: acreedor.demandante, montoDeuda: parseInt(acreedor.monto, 10) },
                                    ],
                                },
                            }))
                        })
                    })
                })
            }
        }

    }, [contractFull]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleNegocioChange = async (event, InNewValue, monto, motivoContratoId) => {
        // -RUT, LINEA DE NEGOCIO
        var newValue = InNewValue
        var _anexo = { codAnexo: '', isAnexo: false }
        if (InNewValue.length > 0) {

            var newValue = [InNewValue[InNewValue.length - 1]]
            if (newValue[0].codCtto == null || newValue[0].codCtto == undefined) {
                _anexo = await CreditorService.GetAnexoId({ identifier: customer.rut, bussinesLine: newValue[0]?.name }); //{isanexo:true,codctto: '...-A1'}
            }


            var aux = newValue.map(x => ({
                ...x,
                //codCtto: x.codCtto ? x.codCtto : `${x.siglas}${Sucursales.find(x => x.id == customer.sucursal).description}${rutCod}${x.anexo ? `-${x.anexo}` : getLegadoAnexo(x.siglas)}`
                codCtto: x.codCtto ? x.codCtto : `${x.siglas}${Sucursales.find(x => x.id == customer.sucursal).description}${rutCod}${_anexo.codAnexo}`
            }))

            if (event == null) {
                var codCtto = contractFull.negocios[0]?.codCtto ?? ''
                var codAnexo = codCtto.split("-")
                if (codCtto.includes("-"))
                    motivoContratoId = 2
                else
                    motivoContratoId = 1

                if (motivoContratoId > 1) {
                    var nuevoMonto = monto ?? ''
                    var isAnexo = motivoContratoId > 1 ? true : false
                    var codCtto = contractFull.negocios[0]?.codCtto ?? ''
                    //var codAnexo = codCtto.split("-")
                    codAnexo = codAnexo[1] ? "-" + codAnexo[1] : ''
                    var motivo = motivoContratoId == 1 ? 'ctto' : 'act'
                    var aan = { ...preAnexo, nuevoMonto, isAnexo, codCtto, codAnexo: '', motivo }
                    dispatch(setPreAnexo(aan))
                }
            } else {
                if (aux[0].codCtto.includes("-"))
                    motivoContratoId = 2
                else
                    motivoContratoId = 1
                var isAnexo = motivoContratoId > 1 ? true : false
                var motivo = motivoContratoId == 1 ? 'ctto' : 'act'
                
                dispatch(setPreAnexo({ ...preAnexo, codCtto: aux[0].codCtto, isAnexo: _anexo.isAnexo, codAnexo: _anexo.codAnexo, motivo }))

            }
            setSelectedNegocios(aux)



            const newServiciosByNegocio = { ...serviciosByNegocio }
            const newSelectedServicios = { ...selectedServicios }

            let sigla
            if (newValue.length > 1) {
                sigla = newValue[0].multiLineas // Usamos el campo multiLineas del primer negocio seleccionado
            } else if (newValue.length === 1) {
                sigla = newValue[0].siglas
            }

            if (sigla) {
                const newContractNumber = generateContractNumber(sigla, formData.fechaNegocio)
                setFormData(prevState => ({
                    ...prevState,
                    numContratos: newContractNumber
                }))
            }

            for (const negocio of newValue) {
                if (!newServiciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id]) {
                    try {
                        const servicios = await CreditorService.getServicioby(negocio.lineId ? negocio.lineId : negocio.id)
                        newServiciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id] = servicios
                        newSelectedServicios[negocio.lineId ? negocio.lineId : negocio.id] = []
                    } catch (error) {
                        //console.error(`Error al obtener servicios para ${negocio.name}:`, error)
                    }
                }
            }
            setServiciosByNegocio(newServiciosByNegocio)
            setSelectedServicios(newSelectedServicios)
        }
    }

    useEffect(() => {
        if (selectedNegocios.length > 0) {
            let sigla;
            if (selectedNegocios.length > 1) {
                sigla = selectedNegocios[0].multiLineas;
            } else {
                sigla = selectedNegocios[0].siglas;
            }

            if (sigla) {
                var newContractNumber = generateContractNumber(sigla, formData.fechaNegocio);
                if (contractFull?.numContratos)
                    newContractNumber = contractFull.numContratos

                setFormData(prevState => ({
                    ...prevState,
                    numContratos: newContractNumber
                }));
            }
        }
    }, [formData.fechaNegocio, selectedNegocios]);


    const handleServicioChange = async (negocioId, selectedServices) => {
        // Extraer los IDs de los servicios seleccionados
        const selectedServiceIds = selectedServices.map(servicio => servicio.id);

        setSelectedServicios(prev => ({
            ...prev,
            [negocioId]: selectedServiceIds
        }));

        for (const servicioId of selectedServiceIds) {
            if (!serviciosAcreedores[negocioId]?.[servicioId]) {
                setServiciosAcreedores(prevAcreedores => ({
                    ...prevAcreedores,
                    [negocioId]: {
                        ...prevAcreedores[negocioId],
                        [servicioId]: []
                    }
                }));
            }

            if (!contractLayouts[servicioId]) {
                try {
                    const layout = await CreditorService.getDocument(servicioId);
                    setContent(layout.layoutURL);
                    setContractLayouts(prevLayouts => ({
                        ...prevLayouts,
                        [servicioId]: layout
                    }));
                } catch (error) {
                    setContractLayouts(prevLayouts => ({
                        ...prevLayouts,
                        [servicioId]: undefined
                    }));
                    //console.error(`Error al obtener el layout para el servicio ${servicioId}:`, error);
                }
            }
        }
    };

    const handleServicioCostChange = (negocioId, servicioId, value) => {
        setServiciosCost(prevCosts => ({
            ...prevCosts,
            [negocioId]: {
                ...prevCosts[negocioId],
                [servicioId]: value
            }
        }));
    };

    const handleServicioCausaChange = (negocioId, servicioId, selectedCausas) => {
        setServiciosCausas(prevCausas => ({
            ...prevCausas,
            [negocioId]: {
                ...prevCausas[negocioId],
                [servicioId]: selectedCausas // Se almacena la lista completa de objetos de causa
            }
        }));
    };

    const handleDeleteServicio = (negocioId, servicioId) => {
        setSelectedServicios(prevSelected => ({
            ...prevSelected,
            [negocioId]: prevSelected[negocioId].filter(id => id !== servicioId)
        }));
        setServiciosCost(prevCosts => ({
            ...prevCosts,
            [negocioId]: {
                ...prevCosts[negocioId],
                [servicioId]: undefined
            }
        }));
        setServiciosAcreedores(prevAcreedores => ({
            ...prevAcreedores,
            [negocioId]: {
                ...prevAcreedores[negocioId],
                [servicioId]: undefined
            }
        }));
    };

    const handleAcreedorChange = (negocioId, servicioId, newValue) => {
        setSelectedAcreedor((prev) => ({
            ...prev,
            [negocioId]: {
                ...prev[negocioId],
                [servicioId]: newValue,
            },
        }));
    };

    // Actualiza el input del Autocomplete
    const handleInputChange = (negocioId, servicioId, newInputValue) => {
        setInputValue((prev) => ({
            ...prev,
            [negocioId]: {
                ...prev[negocioId],
                [servicioId]: newInputValue,
            },
        }));
    };

    // Función para eliminar un acreedor específico
    const handleDeleteAcreedor = (negocioId, servicioId, index) => {
        setServiciosAcreedores((prev) => ({
            ...prev,
            [negocioId]: {
                ...prev[negocioId],
                [servicioId]: prev[negocioId][servicioId].filter((_, i) => i !== index),
            },
        }));
    };

    // Función para calcular el total de deuda
    const getTotalDeuda = (negocioId, servicioId) => {
        return serviciosAcreedores?.[negocioId]?.[servicioId]?.reduce(
            (total, acreedor) => total + (parseInt(acreedor.montoDeuda, 10) || 0),
            0
        );
    };

    // Agrega acreedor y monto de deuda a serviciosAcreedores
    const addAcreedor = (negocioId, servicioId) => {
        //perro
        const acreedorSeleccionado = selectedAcreedor?.[negocioId]?.[servicioId];
        const deuda = montoDeuda?.[negocioId]?.[servicioId];

        if (acreedorSeleccionado && deuda) {
            setServiciosAcreedores((prev) => ({
                ...prev,
                [negocioId]: {
                    ...prev[negocioId],
                    [servicioId]: [
                        ...(prev[negocioId]?.[servicioId] || []),
                        { nombre: acreedorSeleccionado.name, montoDeuda: parseInt(deuda, 10) },
                    ],
                },
            }));

            // Limpiar campos después de agregar
            setSelectedAcreedor((prev) => ({
                ...prev,
                [negocioId]: { ...prev[negocioId], [servicioId]: null },
            }));
            setMontoDeuda((prev) => ({
                ...prev,
                [negocioId]: { ...prev[negocioId], [servicioId]: "" },
            }));
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        var _continue = true


        selectedNegocios.map(negocio => {
            var ss = selectedServicios[negocio.lineId ? negocio.lineId : negocio.id]
            ss.map(servicioId => {
                var montoAsi = serviciosCost[negocio.lineId ? negocio.lineId : negocio.id]?.[servicioId] ?? 0
                var montoMin = serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id].find(s => s.id === servicioId)?.minAmount ?? 0

                if (montoAsi < montoMin) {
                    Swal.fire({
                        title: serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id].find(s => s.id === servicioId)?.name ?? 'Servicio',
                        text: `El monto no puede ser menor a ${formatToCLP(montoMin)}`,
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                    _continue = false;
                }

            })
        })
        if (!_continue) return

        var formattedData = preFormattedData || {
            ...formData,
            Id: contractFull?.contractId ? contractFull.contractId : 0,
            InterviewId: interview.id,
            customerId: customer.id,
            negocios: selectedNegocios.map(negocio => ({
                ...negocio,
                servicios: selectedServicios[negocio.lineId ? negocio.lineId : negocio.id].map(servicioId => ({
                    id: servicioId,
                    name: serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id].find(s => s.id === servicioId).name,
                    costo: serviciosCost[negocio.lineId ? negocio.lineId : negocio.id]?.[servicioId] ??
                        serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id].find(s => s.id === servicioId)?.minAmount ?? 0,
                    causas: serviciosCausas[negocio.lineId ? negocio.lineId : negocio.id]?.[servicioId] || [],
                    acreedores: serviciosAcreedores[negocio.lineId ? negocio.lineId : negocio.id]?.[servicioId] || [],
                    interviewId: interview.id
                }))
            }))
        };


        try {

            if (formattedData.negocios.length == 0) {
                Swal.fire({
                    title: 'Atención',
                    text: 'Falta Linea de negocio y Servicios',
                    icon: 'warning',
                    confirmButtonText: 'Aceptar'
                });
                return;
            }
            else if (formattedData.negocios[0].servicios.length == 0) {
                Swal.fire({
                    title: 'Atención',
                    text: 'Falta Linea de negocio y Servicios',
                    icon: 'warning',
                    confirmButtonText: 'Aceptar'
                });
                return;
            }

            if (causasList.length > 0) {
                if (formattedData.negocios[0].servicios.length == 1) {
                    if (causasList.length != formattedData.negocios[0].servicios[0].causas.length) {
                        formattedData.negocios[0].servicios[0].causas = causasList
                    }
                } else if (formattedData.negocios[0].servicios.length > 1) {
                    var contador = 0
                    formattedData.negocios[0].servicios.forEach(servicio => {
                        contador += servicio.causas.length
                    })
                    if (contador != causasList.length) {
                        setShowAsignarCausas(true)
                        setPreFormattedData(formattedData)
                        return
                    }
                }
            }

            const contrato = await CreditorService.saveContract(formattedData);
            await CreditorService.saveExtraAnexo({ ...preAnexo, ContractLineId: contrato.contract_Line[0].id });

            contrato.contract_Line.forEach(lob => {
                var negocioId = lob.id
                lob.contractServices.forEach(async servicio => {
                    var acreedores = serviciosAcreedores[negocioId]?.[servicio.id] || []
                    if (acreedores.length >= 1) {

                        var dataMapped = acreedores?.map(acreedor => ({
                            identifier: formattedData.rut,          // RUT del acreedor
                            customerId: formattedData.customerId,          // ID del cliente
                            demandante: acreedor.nombre,          // Nombre del demandante
                            monto: acreedor.montoDeuda || 0,      // Monto, con 0 como valor predeterminado si es nulo
                            createdBy: getConsultantId(),      // ID del usuario autenticado
                            IdStatus: acreedor.IdStatus || 1,      // Estado, con 1 como valor predeterminado
                            contractServiceId: servicio.contractServiceId
                        })) || [];

                        await CustomerService.registrarAcreedores(dataMapped);
                    }
                });
            });


            // Mostrar mensaje de éxito
            Swal.fire({
                title: 'Éxito',
                text: 'El contrato se han guardado correctamente.',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            });
            // navigate('/CuotasPage', { state: {  formData:formattedData } });  // Pasar datos en la navegación
            dispatch(setTab("3"));
            dispatch(setContractFull(formattedData));
        } catch (error) {
            // Mostrar mensaje de error
            Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al intentar guardar el contrato. Por favor, inténtelo de nuevo.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
        }

    };

    const handleCausaChange = (causaId, servicioId) => {
        setCausasList(prevLista =>
            prevLista.map(item =>
                item.id === causaId ? { ...item, servicioId } : item
            )
        )
    }
    const handleCausaConfirm = () => {
        const asociados = causasList.every(item => item.servicioId !== null && item.servicioId !== undefined);
        if (!asociados) {
            Swal.fire({
                title: 'Atencion!',
                text: 'Faltan Causas por asignar',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                customClass: { popup: 'swal-front' }
            })
        } else {
            var data = preFormattedData
            data.negocios.forEach(negocio => {
                negocio.servicios.forEach(servicio => {
                    const causasDelServicio = causasList.filter(causa => causa.servicioId === servicio.id);
                    if (causasDelServicio.length > 0) {
                        servicio.causas = causasDelServicio;
                    }
                });
            });

            setPreFormattedData(data)
            setShowAsignarCausas(false)
            setTimeout(() => {
                //handleSubmit()
                handleSubmit({ preventDefault: () => { } });
            }, 100);
        }
    }

    const isDefensaDeudores = (negocioId) => {
        const negocio = negocioList.find(n => n.id === negocioId);
        return negocio && negocio.name === "Defensa Deudores";
    };

    const processString = (str) => {
        if (!str) return '';
        // Eliminar espacios y puntos, separar por guión y devolver la posición 0
        const parts = str.replace(/\s|\./g, '').split('-');
        return parts[0] || '';
    };

    const getLegadoAnexo = (siglas) => {
        var cttoLegado = CttosOld.find(x => x.aliasNegocio == siglas)
        if (cttoLegado == null) return "";
        if (cttoLegado.codigoContrato == null) return "";

        var cod = cttoLegado.codigoContrato.split('-')
        if (cod.length == 1) {
            return "-A1";
        } else if (cod.length > 1) {
            const lastElement = cod[cod.length - 1];
            const match = lastElement.match(/A(\d+)/);
            const number = match ? parseInt(match[1], 10) : 0;
            return "-A" + (number + 1);
        }
        return "";
    }

    const addAllAcreedor = (index, negocioId, servicioId) => {
        var acreedor = allAcreedores.list[index]

        setServiciosAcreedores((prev) => ({
            ...prev,
            [negocioId]: {
                ...prev[negocioId],
                [servicioId]: [
                    ...(prev[negocioId]?.[servicioId] || []),
                    { nombre: acreedor.demandante, montoDeuda: parseInt(acreedor.monto, 10) },
                ],
            },
        }));

        setAllAcreedores((prev) => ({
            ...prev,
            list: prev.list.filter((_, i) => i !== index),
        }));
        ////////////////////////////////////////////////
    }

    const [finiquitado, setFiniquitado] = useState(false);
    const [cancelado, setCancelado] = useState(false);
    const [bloquearAcciones, setBloquearAcciones] = useState(false);

    useEffect(() => {
        if (_TAB.contractFull?.cancel == true) {
            setCancelado(true)
            setBloquearAcciones(true)
        }
        if (_TAB.contractFull?.finiquitado == true) {
            setFiniquitado(true)
            setBloquearAcciones(true)
        }
    }, [_TAB])



    const handleCreateOption = async (inputValue, servicioId, negocio) => {

        try {
            var id = await CreditorService.AddCreditor(inputValue);

            const opcionDesdeServidor = {
                value: id,
                label: inputValue,
            };
            /*
            setAcreedoresList((prev) => [...prev, opcionDesdeServidor]);
            setNewCase((prev) => ({ ...prev, demandante: id }));
            */
            const nuevaOpcion = { value: inputValue, label: inputValue };
            setAcreedoresList((prev) => [...prev, nuevaOpcion]);
            handleAcreedorChange(
                negocio.lineId || negocio.id,
                servicioId,
                { id: inputValue, name: inputValue }
            );


            Swal.fire({
                title: 'Éxito',
                text: 'Acreedor creado correctamente',
                icon: 'success',
                confirmButtonText: 'Aceptar',
                customClass: {
                    popup: 'swal-front'
                }
            })
        } catch (error) {
            console.error('Error creando acreedor:', error);
            Swal.fire({
                title: 'Error',
                text: 'Acreedor no creado',
                icon: 'errot',
                confirmButtonText: 'Aceptar',
                customClass: {
                    popup: 'swal-front'
                }
            })
        }
    };

    return (<>
        <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
            <Alert className='mb-4' severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>
            <Alert className='mb-4' severity="warning" hidden={!cancelado}>Contrato Cancelado.</Alert>

            <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} hidden>
                        <TextField
                            fullWidth
                            label="N° Contratos"
                            name="numContratos"
                            value={formData.numContratos || ""}
                            onChange={handleChange}
                            disabled
                            hidden />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            label="RUT"
                            name="rut"
                            value={formData.rut || ""}
                            onChange={handleChange}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">

                            <DatePicker
                                fullWidth
                                required
                                id="fecha"
                                label="Fecha"
                                name="fechaNegocio"
                                value={formData?.fechaNegocio ? dayjs(formData.fechaNegocio) : null}
                                onChange={(newValue) => handleChange({ target: { name: 'fechaNegocio', value: newValue } })}
                                renderInput={(params) => <TextField {...params} />}
                                disabled />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            label="Nombre"
                            name="nombre"
                            value={formData.nombre || ""}
                            onChange={handleChange}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            multiple
                            options={negocioList}
                            getOptionLabel={(option) => option.name}
                            value={selectedNegocios}
                            onChange={handleNegocioChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Líneas de Negocio"
                                    variant="outlined"
                                />
                            )}
                            disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                        />

                        <FormHelperText> <span style={{ color: 'red' }}> (Campo obligatorio) </span></FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        {selectedNegocios.map((negocio) => (
                            <Accordion key={negocio.lineId ? negocio.lineId : negocio.id}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography className='w-50' variant="h6">
                                        {negocio.name} - Servicios contratados: {selectedServicios ? selectedServicios[negocio.lineId ? negocio.lineId : negocio.id]?.length || 0 : 0}
                                    </Typography>
                                    <Typography className='w-50 text-end me-3' variant="h6">
                                        {negocio.codCtto}
                                    </Typography>

                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    multiple
                                                    options={serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id] || []}
                                                    getOptionLabel={(option) => option.name}
                                                    value={
                                                        serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id]?.filter(servicio =>
                                                            selectedServicios[negocio.lineId ? negocio.lineId : negocio.id]?.includes(servicio.id)
                                                        ) || []
                                                    }
                                                    onChange={(event, newValue) => {
                                                        handleServicioChange(negocio.lineId ? negocio.lineId : negocio.id, newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Servicios" placeholder="Buscar servicio" />
                                                    )}
                                                    renderOption={(props, option, { selected }) => (
                                                        <li {...props}>
                                                            <Checkbox
                                                                style={{ marginRight: 8 }}
                                                                checked={selected}
                                                            />
                                                            {option.name}
                                                        </li>
                                                    )}

                                                    disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                    disableCloseOnSelect
                                                />
                                                <FormHelperText>      <span style={{ color: 'red' }}>
                                                    (Campo obligatorio)
                                                </span></FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Servicio</TableCell>
                                                            <TableCell>Costo del Servicio</TableCell>
                                                            {/**** zona configuracion de anexo *****/}
                                                            {preAnexo.isAnexo ? <TableCell>Costo Anterior del Servicio</TableCell> : null}
                                                            <TableCell>Monto Minimo Servicio</TableCell>
                                                            <TableCell>Tope de Cuotas</TableCell>
                                                            <TableCell>Acciones</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {selectedServicios[negocio.lineId ? negocio.lineId : negocio.id]?.map((servicioId) => {
                                                            // Obtenemos el servicio seleccionado por su ID
                                                            const servicio = serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id].find(s => s.id === servicioId);
                                                            // Si el servicio tiene un minAmount, lo usamos para precargar el valor
                                                            const minAmount = servicio?.minAmount || 0;
                                                            return (
                                                                <TableRow key={servicioId}>
                                                                    <TableCell>{servicio.name}</TableCell>

                                                                    <TableCell>
                                                                        <NumericFormat
                                                                            required
                                                                            customInput={TextField}
                                                                            value={serviciosCost[negocio.lineId ? negocio.lineId : negocio.id]?.[servicioId] || ''}
                                                                            onValueChange={(values) => handleServicioCostChange(negocio.lineId ? negocio.lineId : negocio.id, servicioId, values.value)}
                                                                            thousandSeparator="."
                                                                            decimalSeparator=","
                                                                            prefix="$"
                                                                            allowNegative={false}
                                                                            decimalScale={0} // Escala de decimales en 0 para formato CLP
                                                                            disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                                            min={minAmount} // Establece el valor mínimo
                                                                            defaultValue={minAmount ?? ''} // Establece el valor por defecto
                                                                        />
                                                                    </TableCell>

                                                                    {/**** zona configuracion de anexo *****/}

                                                                    {preAnexo.isAnexo ?

                                                                        <TableCell >
                                                                            <NumericFormat
                                                                                required
                                                                                customInput={TextField}
                                                                                value={preAnexo.nuevoMonto ?? ''}
                                                                                onValueChange={(e) => dispatch(setPreAnexo({ ...preAnexo, nuevoMonto: e.value }))}
                                                                                thousandSeparator="."
                                                                                decimalSeparator=","
                                                                                prefix="$"
                                                                                allowNegative={false}
                                                                                decimalScale={0} // Escala de decimales en 0 para formato CLP
                                                                                disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                                                min={minAmount} // Establece el valor mínimo
                                                                                defaultValue={minAmount ?? ''} // Establece el valor por defecto
                                                                            />
                                                                        </TableCell>
                                                                        : null}


                                                                    <TableCell>
                                                                        {formatToCLP(minAmount)}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {servicio.maxCuota}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <IconButton
                                                                            disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                                            onClick={() => handleDeleteServicio(negocio.lineId ? negocio.lineId : negocio.id, servicioId)}>
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}

                                                    </TableBody>

                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                        {/********************************************************************** */}
                                        {selectedServicios[negocio.lineId ? negocio.lineId : negocio.id]?.map((servicioId) => (
                                            <Grid item xs={12}>
                                                <Divider sx={{ mt: 3, mb: 3 }}>
                                                    DETALLE DE {serviciosByNegocio[negocio.lineId ? negocio.lineId : negocio.id].find(s => s.id === servicioId).name.toUpperCase()}
                                                </Divider>
                                                {isDefensaDeudores(negocio.lineId ? negocio.lineId : negocio.id) && (
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={5}>
                                                                <CreatableSelect
                                                                    options={acreedoresList.map(item => ({
                                                                        value: item.id,
                                                                        label: item.name
                                                                    }))}
                                                                    isClearable
                                                                    isSearchable
                                                                    placeholder="Buscar o agregar acreedor"
                                                                    value={
                                                                        (() => {
                                                                            const selected = selectedAcreedor?.[negocio.lineId || negocio.id]?.[servicioId];
                                                                            return selected
                                                                                ? { value: selected.id, label: selected.name }
                                                                                : null;
                                                                        })()
                                                                    }
                                                                    onChange={(selectedOption) => {
                                                                        handleAcreedorChange(
                                                                            negocio.lineId || negocio.id,
                                                                            servicioId,
                                                                            selectedOption
                                                                                ? { id: selectedOption.value, name: selectedOption.label }
                                                                                : null
                                                                        );
                                                                    }}
                                                                    onCreateOption={(e) => handleCreateOption(e, servicioId, negocio)}
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            height: 55,
                                                                            minHeight: 55,
                                                                        }),
                                                                        valueContainer: (base) => ({
                                                                            ...base,
                                                                            paddingTop: 4,
                                                                            paddingBottom: 4,
                                                                        }),
                                                                        input: (base) => ({
                                                                            ...base,
                                                                            margin: 0,
                                                                            padding: 0,
                                                                        }),
                                                                    }}
                                                                    isDisabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                                />


                                                            </Grid>
                                                            <Grid item xs={12} sm={5}>
                                                                <NumericFormat
                                                                    customInput={TextField}
                                                                    fullWidth
                                                                    label="Monto de la Deuda (CLP)"
                                                                    value={montoDeuda?.[negocio.lineId ? negocio.lineId : negocio.id]?.[servicioId] || ""}
                                                                    onValueChange={(values) =>
                                                                        setMontoDeuda((prev) => ({
                                                                            ...prev,
                                                                            [negocio.lineId ? negocio.lineId : negocio.id]: {
                                                                                ...prev[negocio.lineId ? negocio.lineId : negocio.id],
                                                                                [servicioId]: values.value,
                                                                            },
                                                                        }))
                                                                    }
                                                                    thousandSeparator="."
                                                                    decimalSeparator=","
                                                                    prefix="$"
                                                                    allowNegative={false}
                                                                    decimalScale={0}
                                                                    disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={2}>
                                                                <Button
                                                                    fullWidth
                                                                    variant="contained"
                                                                    color="primary"
                                                                    disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                                    onClick={() => addAcreedor(negocio.lineId ? negocio.lineId : negocio.id, servicioId)}
                                                                    startIcon={<AddIcon />} >
                                                                    Agregar
                                                                </Button>
                                                            </Grid>
                                                        </Grid>

                                                        <TableContainer component={Paper} style={{ marginTop: '20px' }} >
                                                            {allAcreedores.list?.map((acreedor, index) => (
                                                                <Grid item xs={12} key={index}>
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12} sm={4}>
                                                                            <TableCell>{acreedor.demandante}</TableCell>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={4}>
                                                                            <NumericFormat
                                                                                customInput={TextField}
                                                                                fullWidth
                                                                                label="Monto de la Deuda (CLP).."
                                                                                defaultValue={acreedor.monto}
                                                                                onValueChange={(values) => setAllAcreedores((prev) => ({ // agregar al allacreedor
                                                                                    ...prev,
                                                                                    list: prev.list.map((item, i) =>
                                                                                        i === index ? { ...item, monto: values.floatValue } : item
                                                                                    ),
                                                                                }))
                                                                                }
                                                                                thousandSeparator="."
                                                                                decimalSeparator=","
                                                                                prefix="$"
                                                                                allowNegative={false}
                                                                                decimalScale={0}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={4}>

                                                                            <TableCell>
                                                                                <Button
                                                                                    fullWidth
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    onClick={() => addAllAcreedor(index, negocio.lineId ? negocio.lineId : negocio.id, servicioId)}
                                                                                    startIcon={<AddIcon />}
                                                                                >
                                                                                    Confirmar
                                                                                </Button>
                                                                            </TableCell>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>

                                                            ))}

                                                        </TableContainer>
                                                        {serviciosAcreedores[negocio.lineId ? negocio.lineId : negocio.id] &&
                                                            serviciosAcreedores[negocio.lineId ? negocio.lineId : negocio.id][servicioId] &&
                                                            serviciosAcreedores[negocio.lineId ? negocio.lineId : negocio.id][servicioId].length > 0 && (
                                                                <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell>Acreedor</TableCell>
                                                                                <TableCell align="right">Monto de Deuda</TableCell>
                                                                                <TableCell >Acciones</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {serviciosAcreedores[negocio.lineId ? negocio.lineId : negocio.id]?.[servicioId].map((acreedor, index) => (
                                                                                <TableRow key={index}>
                                                                                    <TableCell>{acreedor.nombre}</TableCell>
                                                                                    <TableCell align="right">{formatToCLP(acreedor.montoDeuda)}</TableCell>
                                                                                    <TableCell>
                                                                                        <IconButton
                                                                                            disabled={(!allowUpdate || bloquearAcciones) ? true : false}
                                                                                            onClick={() => handleDeleteAcreedor(negocio.lineId ? negocio.lineId : negocio.id, servicioId, index)}>
                                                                                            <DeleteIcon />
                                                                                        </IconButton>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                            <TableRow>
                                                                                <TableCell><strong>Total</strong></TableCell>
                                                                                <TableCell align="right"><strong>{formatToCLP(getTotalDeuda(negocio.lineId ? negocio.lineId : negocio.id, servicioId))}</strong></TableCell>
                                                                            </TableRow>

                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            )}
                                                    </Grid>
                                                )}

                                            </Grid>
                                        ))}
                                    </Grid>

                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Grid>
                    <Grid item xs={12} >
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>


                            {(allowUpdate && !bloquearAcciones) ?
                                <Button variant="contained" startIcon={<AddIcon />} type="submit" size="large" >
                                    Guardar y Continuar
                                </Button>
                                :
                                <Button
                                    variant="contained"
                                    color="success"
                                    startIcon={<SkipNext />}
                                    size="large"
                                    onClick={() => dispatch(setTab("3"))} // Utilizar la función combinada
                                > Continuar </Button>
                            }
                        </Box>
                    </Grid>
                </Grid>
            </form>


        </Paper>
        <Modal
            open={showAsignarCausas}
            onClose={() => setShowAsignarCausas(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ maxHeight: '90vh', overflowY: 'auto' }}
        >
            <Box className="apple-modal" sx={{
                position: 'absolute', top: '50%', left: '50%',
                width: 'auto', transform: 'translate(-50%, -50%)',
                maxHeight: '90vh', overflowY: 'auto'
            }}>
                <Typography variant="h6" component="div" sx={{ p: 2 }}>Por favor, Asignar Causas a servicios</Typography>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Causa</TableCell>
                                <TableCell>Servicio</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {causasList?.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" sx={{ width: 500 }}>
                                        <ListItemText m={0} primary={`${row.rol}`} />
                                        <ListItemText m={0} primary={`${row.tribunal}`} />
                                        <ListItemText m={0} primary={`${row.demandante}`} />
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        <FormControl variant="standard" fullWidth>
                                            <InputLabel>seleccion servicio </InputLabel>
                                            <Select
                                                onChange={(e) => handleCausaChange(row.id, e.target.value)}
                                                sx={{ width: 300, color: '#000' }}
                                                label="Seleccione servicio"
                                                defaultValue={row.servicioId || null}>
                                                {preFormattedData?.negocios[0]?.servicios?.map((s) =>
                                                    <MenuItem value={s.id}>{s.name}</MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button sx={{ mt: 2 }} variant='outlined' onClick={handleCausaConfirm}>Confirmar</Button>
                </div>
            </Box>
        </Modal>

    </>);
};

export default LineaNegocioForm;